/**
 * KAN-951: video of a help section, 16:9. A file that cannot be played
 * gives a note instead of a black player; the parent remounts it (key)
 * for another section, so the next video is tried again.
 */
import { forwardRef, useState } from 'react';

interface HelpVideoProps {
  src: string;
  title: string;
  onEnded: () => void;
  /** The file cannot be played (the playlist moves on). */
  onFailed: () => void;
}

export const HelpVideo = forwardRef<HTMLVideoElement, HelpVideoProps>(function HelpVideo(
  { src, title, onEnded, onFailed },
  ref
) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <p
        role="status"
        className="flex aspect-video w-full items-center justify-center rounded-lg bg-gray-100 px-4 text-center text-base text-gray-600"
      >
        Видео для этого раздела скоро появится
      </p>
    );
  }

  return (
    <div className="aspect-video w-full overflow-hidden rounded-lg bg-black">
      <video
        ref={ref}
        src={src}
        controls
        playsInline
        preload="metadata"
        aria-label={title}
        onEnded={onEnded}
        onError={() => {
          setFailed(true);
          onFailed();
        }}
        className="h-full w-full"
      >
        Ваш браузер не поддерживает воспроизведение видео.
      </video>
    </div>
  );
});
